import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import Notifications from "../icons/Notifications";

const NotificationsIcon = styled(Notifications)`
    position: relative;
    left: 0.4375rem;
    top: 0.1875rem;
    width: 1rem;
    height: 1rem;
`;

const HasNotifications = ({ hasNotifications }) => (
    <>
        Activity
        {hasNotifications && (
            <NotificationsIcon title="Activity Notifications" />
        )}
    </>
);

HasNotifications.defaultProps = {
    hasNotifications: false
};

HasNotifications.propTyes = {
    hasNotifications: PropTypes.bool
};

export default HasNotifications;
